import React, { useEffect, useState } from "react";
import { useNavigate, NavLink, Link } from "react-router";

import "./styles.css"; // Custom styles for the app

import { useData } from "./data/dataContext";
import { AirbudsYearlyHeader } from "./component/storyHeader";
import { useMusicPlayer } from "./music/musicPlayerContext";
import MusicButton from "./music/musicButton";

export const Home = ({}) => {
  let navigate = useNavigate();
  const { data } = useData();

  return (
    <div className="app">
      <div className="content">
        <div className="image-background">
          <p></p>
        </div>
        <div className="intro-title-content">
          <div className="intro-title">
            <h3>your</h3>
            <img
              src={require("./assets/img/chrome2024.png")}
              alt="airbuds yearly recap"
            />
            <h1>
              Music Recap
              <br />
              is Ready
            </h1>
          </div>

          {data && (
            <div className="full-width-content">
              <button
                onClick={() => {
                  if (localStorage.getItem("hasOnboard")) {
                    navigate("/menu");
                  } else {
                    localStorage.setItem("hasOnboard", true);
                    navigate("/intro");
                  }
                }}
                className="big-cta-button"
              >
                Discover now
              </button>
            </div>
          )}
        </div>

        {!data && <p>Loading...</p>}
      </div>

      <AirbudsYearlyHeader hideMenuBanner={true} />
    </div>
  );
};
